export { default } from './StepsWithAnchors';
